<template>
  <div class="row">
    <div class="flex xs12">
      <va-card :title="inviterPage?'邀请列表':'用户'">
        <va-data-table
          :fields="fields"
          :data="users"
          :loading="loading"
          :totalPages="totalPage"
          @page-selected="listInterviewUser"
          api-mode
        >
          <template slot="avatar" slot-scope="props">
            <img :src="props.rowData.avatar" class="data-table-server-pagination---avatar" alt="avatar">
          </template>
          <template slot="typeSlot" slot-scope="props">
            <va-badge :color= computeStatus(props.rowData.subscriptionType).color>
              {{ computeStatus(props.rowData.subscriptionType).text }}
            </va-badge>
          </template>
          <template slot="period" slot-scope="props">
            {{ formatPeriodTime(props.rowData.startTime, props.rowData.endTime) }}
          </template>
          <template slot="registerTime" slot-scope="props">
            {{ formatRegisterTime(props.rowData.registerTime) }}
          </template>
          <template slot="lastInterviewTime" slot-scope="props">
            {{ formatRegisterTime(props.rowData.lastInterviewTime) }}
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="查看" placement="top">
              <va-button flat small color="gray" icon="fa fa-eye"
                :to='{path:`getUser/${props.rowData.uid}`}'/>
            </va-popover>
          </template>
        </va-data-table>
      </va-card>
    </div>
  </div>
</template>

<script>

import { formatTime } from '@/utils/common'
import interviewApi from '../../api/interview'

export default {
  data () {
    return {
      message: ['Required field'],
      users: [],
      loading: true,
      allCount: 0,
      totalPage: null,
      inviterUid: null,
      inviterPage: false,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:avatar',
          title: '头像',
          width: '50px',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'nickname',
          title: '用户名',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: '__slot:typeSlot',
          title: '订阅状态',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '10%',
        },
        {
          name: '__slot:period',
          title: '有效期',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '25%',
        },
        {
          name: '__slot:registerTime',
          title: '注册时间',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: 'interviewCount',
          title: '面试次数',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '5%',
        },
        {
          name: '__slot:lastInterviewTime',
          title: '最近面试时间',
          titleClass: 'text-center',
          dataClass: 'text-center',
          width: '15%',
        },
        {
          name: '__slot:actions',
          title: '操作',
          titleClass: 'text-center',
          width: '15%',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.inviterUid = this.$route.query.inviterUid
    if (this.inviterUid != null) {
      this.inviterPage = true
    }
    this.listInterviewUser()
  },
  methods: {
    listInterviewUser (pageNumber = 1) {
      this.loading = true
      const data = {
        pageSize: 50,
        pageNumber: pageNumber,
        inviterUid: this.inviterUid,
        startTime: this.startTime,
        endTime: this.endTime,
      }
      interviewApi.listUser(data)
        .then(response => {
          console.log(response)
          this.users = response.userList
          this.totalCount = response.totalCount
          this.totalPage = response.totalPage
          this.loading = false
        })
    },
    computeStatus: function (status) {
      const data = {
        color: 'success',
        text: '免费',
      }
      if (status === 1) {
        data.color = 'danger'
        data.text = 'monthly_essential'
      } else if (status === 2) {
        data.color = '#6be59c'
        data.text = 'monthly_pro'
      } else if (status === 3) {
        data.color = '#f6d35b'
        data.text = 'quarterly_essential'
      } else if (status === 4) {
        data.color = '#6bbfe4'
        data.text = 'quarterly_pro'
      }
      return data
    },
    formatRegisterTime: function (time) {
      return formatTime(time)
    },
    formatPeriodTime: function (start, end) {
      return formatTime(start) + ' - ' + formatTime(end)
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
</style>
